// Dependencies
import React, { useState, useEffect, useRef, useCallback, useContext } from "react";

// Types
import { Types, Components } from '../types';

// Utils
import {  } from '../utils/config'
import {  } from '../utils/helpers'  

// Hooks
import { useDebug } from "../hooks";

// Components
import Price from "./Price"; 
import CartIcon from "./CartIcon";
import { MinicartContext } from "../contexts/Minicart";

const CartHeader = ({icon, className}: Components.CartHeader) => {
    useDebug('CartHeader'); 
     
    // Contexts
    const { loading, opened, itemsCount, itemsSubtotal, toggleState, config, translations, theme } = useContext( MinicartContext );

    return ( 
        <button tabIndex={0} disabled={loading || opened} className={className} onClick={() => toggleState('opened')}>
            <CartIcon 
                className={`${className}__icon`}
                icon={icon}
                quantity={itemsCount}
                {...{ loading }}
                {...{config, translations, theme}}
                />
            <Price 
                value={itemsSubtotal}
                {...{ loading }}
                {...{config, translations, theme}}
            />
  
        </button>
    )
    
}

export default CartHeader; 